

module.exports = {
    supportedTypes: require('./types'),
    ascii: require('./ascii'),
    gs1: require('./gs1'),
    iata: require('./iata'),
    isoIec15962: require('./isoIec15962'),
    rfid: require('./rfid')
};